//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const exclude = useStore((state) => state.exclude);
  const setExclude = useStore((state) => state.setExclude);
  const [next, setNext] = useState(exclude.length > 0);

  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    if (exclude.length >= 2 && exclude.includes('no_allergies')) {
      setNext(false);
    }
  }, []);

  const handleChange = (value) => {
    if (value.includes('no_allergies')) {
      if (value.length === 1) {
        setNext(true);
        onNext();
      } else {
        setNext(false);
        return;
      }
      setNext(false);
    }
    setExclude(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2' style={{ padding: '0px 20px' }}>
          {t('onboarding.exclude.title')}
        </Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={exclude} onChange={handleChange}>
          <MultiOption value={'no_allergies'}>
            <span>🙂</span> {t('onboarding.exclude.options.no_allergies')}
          </MultiOption>
          <MultiOption value={'gluten'}>
            <span>🥖</span> {t('onboarding.exclude.options.gluten')}
          </MultiOption>
          <MultiOption value={'wheat'}>
            <span>🌾</span> {t('onboarding.exclude.options.wheat')}
          </MultiOption>
          <MultiOption value={'lactose'}>
            <span>🥛</span> {t('onboarding.exclude.options.lactose')}
          </MultiOption>
          <MultiOption value={'nuts'}>
            <span>🥜</span> {t('onboarding.exclude.options.nuts')}
          </MultiOption>
          <MultiOption value={'eggs'}>
            <span>🥚</span> {t('onboarding.exclude.options.eggs')}
          </MultiOption>
          <MultiOption value={'fish'}>
            <span>🐟</span> {t('onboarding.exclude.options.fish')}
          </MultiOption>
          <MultiOption value={'meat'}>
            <span>🥩</span> {t('onboarding.exclude.options.meat')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.exclude.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'exclude',
              answer: exclude.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
